import script from "./ServiceTaskCalendar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServiceTaskCalendar.vue?vue&type=script&lang=ts&setup=true"

import "./ServiceTaskCalendar.vue?vue&type=style&index=0&id=053e6745&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-053e6745"]])

export default __exports__